import { Fragment, useState, useMemo } from "react";
import { useParams } from "react-router";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { ReactTableDataGrid } from "components/Table";
import useCallApi from "hook/useCallApi";
import useInViewport from "hook/useInViewport";
import { getProductDetailLive } from "actions/spyAdvancedActions";
import cx from "classnames";
import { heightRow } from "../../../constant";
import useColumnTableProductLive from "../../../hooks/useColumnTableProductLive";

const limit = 20;

const sorts = [
    { label: "Watch PV", value: "viewers_count" },
    { label: "NumberOfSku", value: "total_product_cnt" },
    { label: "GMV", value: "product_gmv_amt" },
    { label: "Sales", value: "product_sale_cnt" },
];

function LiveList({ getProductDetailLive }) {
    const { t } = useTranslation();
    const { id } = useParams();
    const [page, setPage] = useState(1);
    const [ref, inView] = useInViewport({ threshold: 0.2, once: true });
    const [filter, setFilter] = useState({ order: "publish_time", sort: "sort" });
    const params = useMemo(() => ({ ...filter, page, per_page: limit, productId: id }), [filter, page, id]);
    const { data, loading } = useCallApi(getProductDetailLive, params, inView);
    const columns = useColumnTableProductLive(heightRow);

    const onTableChanged = ({ page }) => {
        if (page) setPage(page);
    };

    const handleChangeSort = (value) => {
        setPage(1);
        setFilter((prev) => {
            let sort = "desc";
            if (prev.order === value && prev.sort === "desc") sort = "asc";

            return { ...prev, order: value, sort };
        });
    };

    return (
        <Fragment>
            <div className="card mt-5 mb-5 mb-xl-10" ref={ref}>
                <div
                    className="card-header border-0 cursor-pointer"
                    role="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_account_profile_details"
                    aria-expanded="true"
                    aria-controls="kt_account_profile_details"
                >
                    <div className="card-title m-0">
                        <h3 className="fw-bold m-0">{t("Live List")}</h3>
                    </div>
                </div>
                <div className="card-body" style={{ minHeight: "400px" }}>
                    {loading ? (
                        <div className="w-100 d-flex justify-content-center">
                            <div className="spinner-border text-primary" role="status">
                                <span className="sr-only"></span>
                            </div>
                        </div>
                    ) : (
                        <>
                            <div className="d-flex bg-light p-4 gap-8 text-muted">
                                <div>Sort: </div>
                                {sorts.map(({ label, value }, key) => (
                                    <div
                                        key={key}
                                        className={cx(
                                            "d-flex justify-content-center align-items-center gap-1 al-cursor-pointer",
                                            { "text-info": value === filter.order }
                                        )}
                                        onClick={() => handleChangeSort(value)}
                                    >
                                        {label}
                                        {Boolean(filter?.sort) &&
                                            filter.order === value &&
                                            (filter.sort === "asc" ? (
                                                <i
                                                    className={cx("ki-duotone ki-black-up", {
                                                        "text-info": value === filter.order,
                                                    })}
                                                ></i>
                                            ) : (
                                                <i
                                                    className={cx("ki-duotone ki-black-down", {
                                                        "text-info": value === filter.order,
                                                    })}
                                                ></i>
                                            ))}
                                    </div>
                                ))}
                            </div>
                            <ReactTableDataGrid
                                tableName="ProductLiveList"
                                idProperty="_id"
                                columns={columns}
                                rowData={data?.data || []}
                                pageNumber={page}
                                gridOptions={{
                                    rowHeight: heightRow,
                                    reactiveCustomComponents: true,
                                }}
                                paginationPageSize={limit}
                                totalSize={data?.meta?.total || 0}
                                emptyText={"No data!"}
                                isSearchText={false}
                                onTableChanged={onTableChanged}
                                height="calc(100vh - 300px)"
                                showAllColumns={true}
                            />
                        </>
                    )}
                </div>
            </div>
        </Fragment>
    );
}

const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
    getProductDetailLive,
};

export default connect(mapStateToProps, mapDispatchToProps)(LiveList);
